import {
  CHANGE_ANSWER,
  CHANGE_TREE_SELECT_CHOICES,
  FAILURE_FETCH_INITIAL_SURVEY_STEP,
  FAILURE_FETCH_SURVEY_STEP,
  FAILURE_FETCH_TREE_SELECT_CHOICES,
  FAILURE_POST_ANSWERS,
  FAILURE_POST_COMPLETE_SURVEY,
  HAS_INVALID_ANSWER,
  REQUEST_CHANGE_CURRENT_SURVEY_STEP,
  REQUEST_FETCH_INITIAL_SURVEY_STEP,
  REQUEST_FETCH_SURVEY_STEP,
  REQUEST_FETCH_TREE_SELECT_CHOICES,
  REQUEST_POST_ANSWERS,
  REQUEST_POST_COMPLETE_SURVEY,
  RESET_ERROR_TOAST,
  RESET_KEY_BIND_EXPLANATION,
  RESET_TREE_SELECT_CHOICES,
  SLIDE_NEXT_STEP,
  SLIDE_PREV_STEP,
  SUCCESS_CHANGE_CURRENT_SURVEY_STEP,
  SUCCESS_FETCH_INITIAL_SURVEY_STEP,
  SUCCESS_FETCH_SURVEY_STEP,
  SUCCESS_FETCH_TREE_SELECT_CHOICES,
  SUCCESS_POST_ANSWERS,
  SUCCESS_POST_COMPLETE_SURVEY,
  TOGGLE_TREE_SELECT_DIVE_MODAL,
  TOGGLE_TREE_SELECT_SEARCH_MODAL,
  VERIFY_ANSWER,
} from 'actions/actionTypes';
import { SurveyActionTypes, SurveyState, SurveyStepItemTypes, SurveyStepTypes } from 'types/survey';
import reverseChoices from '../../utils/reverseChoices';

export const initialState: SurveyState = {
  isLoading: false,
  isInitialized: false,
  isCompleted: false,
  isClosed: false,
  isNotFound: false,
  hasError: false, // 各フォームのエラーメッセージ表示用
  hasErrorToast: false,
  toastErrorMessage: '',
  isTreeSelectChoicesLoading: false,
  isOpenTreeSelectSearchModal: false,
  isOpenTreeSelectDiveModal: false,
  isVisibleKeyBindExplanation: true,
  surveyId: 0,
  surveyUserId: 0,
  currentStepNumber: 0,
  totalCount: 0,
  currentSurveyStep: {
    id: '',
    stepType: '',
    stepNumber: 0,
    progressCount: 0,
    enableBack: false,
    surveyStepItems: [],
  },
  surveySteps: [],
  slideDirection: '',
};

const surveyReducer = (state = initialState, action: SurveyActionTypes): SurveyState => {
  switch (action.type) {
    case REQUEST_FETCH_INITIAL_SURVEY_STEP: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SUCCESS_FETCH_INITIAL_SURVEY_STEP: {
      const { payload, deviceVariant } = action;

      const surveySteps: SurveyStepTypes[] = [];

      // エンゲージメント・ステータスの設問でSP版の場合は 10 → 0 に並び替える
      const sortedSurveyStep = reverseChoices(payload, deviceVariant);
      surveySteps[sortedSurveyStep.currentStepNumber - 1] = sortedSurveyStep.currentSurveyStep;

      return {
        ...state,
        isLoading: false,
        isInitialized: true,
        isCompleted: sortedSurveyStep.isCompleted,
        isClosed: sortedSurveyStep.isClosed,
        surveyId: sortedSurveyStep.surveyId,
        surveyUserId: sortedSurveyStep.surveyUserId,
        currentStepNumber: sortedSurveyStep.currentStepNumber,
        totalCount: sortedSurveyStep.totalCount,
        currentSurveyStep: sortedSurveyStep.currentSurveyStep,
        surveySteps,
      };
    }
    case FAILURE_FETCH_INITIAL_SURVEY_STEP: {
      return {
        ...state,
        isLoading: false,
        isNotFound: true,
      };
    }
    case REQUEST_CHANGE_CURRENT_SURVEY_STEP: {
      return {
        ...state,
      };
    }
    case REQUEST_FETCH_SURVEY_STEP: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SUCCESS_FETCH_SURVEY_STEP: {
      const { currentStepNumber, payload, deviceVariant } = action;
      const newSurveySteps = [...state.surveySteps];

      // エンゲージメント・ステータスの設問でSP版の場合は 10 → 0 に並び替える
      const sortedSurveyStep = reverseChoices(payload, deviceVariant);
      const newStepItems = sortedSurveyStep.currentSurveyStep.surveyStepItems.map(
        (surveyStepItem: SurveyStepItemTypes) => {
          if (surveyStepItem.isRequired) {
            if (surveyStepItem.answer.value) {
              return { ...surveyStepItem, valid: true };
            }
            return { ...surveyStepItem, valid: false };
          }
          return surveyStepItem;
        },
      );

      newSurveySteps[currentStepNumber - 1] = {
        ...sortedSurveyStep.currentSurveyStep,
        surveyStepItems: newStepItems,
      };

      return {
        ...state,
        totalCount: sortedSurveyStep.totalCount,
        surveySteps: newSurveySteps,
      };
    }
    case FAILURE_FETCH_SURVEY_STEP: {
      return {
        ...state,
        isLoading: false,
        hasErrorToast: true,
        toastErrorMessage: 'ページを表示できません。時間を置いて更新してください。',
        slideDirection: '',
      };
    }
    case SUCCESS_CHANGE_CURRENT_SURVEY_STEP: {
      const { currentStepNumber } = action;
      const { stepNumber } = state.currentSurveyStep;

      const steps = state.surveySteps;
      steps[stepNumber - 1] = state.currentSurveyStep;

      return {
        ...state,
        isLoading: false,
        hasError: false,
        currentStepNumber,
        surveySteps: steps,
        currentSurveyStep: [...state.surveySteps][currentStepNumber - 1],
        slideDirection: '',
      };
    }
    case TOGGLE_TREE_SELECT_SEARCH_MODAL: {
      const { flag } = action;

      return {
        ...state,
        isOpenTreeSelectSearchModal: flag,
      };
    }
    case TOGGLE_TREE_SELECT_DIVE_MODAL: {
      const { flag } = action;

      return {
        ...state,
        isOpenTreeSelectDiveModal: flag,
      };
    }
    case CHANGE_TREE_SELECT_CHOICES: {
      return {
        ...state,
      };
    }
    case REQUEST_FETCH_TREE_SELECT_CHOICES: {
      return {
        ...state,
        isTreeSelectChoicesLoading: true,
      };
    }
    case SUCCESS_FETCH_TREE_SELECT_CHOICES: {
      const { surveyStepItemId, payload } = action;

      const newStepItems = state.currentSurveyStep.surveyStepItems.map(
        (surveyStepItem: SurveyStepItemTypes) => {
          if (surveyStepItem.id === surveyStepItemId) {
            return { ...surveyStepItem, choices: payload };
          }
          return surveyStepItem;
        },
      );

      return {
        ...state,
        isTreeSelectChoicesLoading: initialState.isTreeSelectChoicesLoading,
        currentSurveyStep: {
          ...state.currentSurveyStep,
          surveyStepItems: newStepItems,
        },
      };
    }
    case FAILURE_FETCH_TREE_SELECT_CHOICES: {
      return {
        ...state,
        isTreeSelectChoicesLoading: initialState.isTreeSelectChoicesLoading,
        hasErrorToast: true,
        toastErrorMessage: '選択肢を表示できません。時間を置いて更新してください。',
        isOpenTreeSelectDiveModal: initialState.isOpenTreeSelectDiveModal,
      };
    }
    case RESET_TREE_SELECT_CHOICES: {
      const { surveyStepItemId } = action;
      const newStepItems = state.currentSurveyStep.surveyStepItems.map(
        (surveyStepItem: SurveyStepItemTypes) => {
          if (surveyStepItem.id === surveyStepItemId) {
            return { ...surveyStepItem, choices: [] };
          }
          return surveyStepItem;
        },
      );

      return {
        ...state,
        currentSurveyStep: {
          ...state.currentSurveyStep,
          surveyStepItems: newStepItems,
        },
      };
    }
    case CHANGE_ANSWER: {
      const { answer } = action;

      const newStepItems = state.currentSurveyStep.surveyStepItems.map(
        (surveyStepItem: SurveyStepItemTypes) => {
          if (surveyStepItem.id === answer.surveyStepItemId) {
            return { ...surveyStepItem, answer };
          }
          return surveyStepItem;
        },
      );

      return {
        ...state,
        currentSurveyStep: {
          ...state.currentSurveyStep,
          surveyStepItems: newStepItems,
        },
      };
    }
    case VERIFY_ANSWER: {
      const newStepItems = state.currentSurveyStep.surveyStepItems.map(
        (surveyStepItem: SurveyStepItemTypes) => {
          if (surveyStepItem.isRequired) {
            if (surveyStepItem.answer.value.trim()) {
              return { ...surveyStepItem, valid: true };
            }
            return { ...surveyStepItem, valid: false };
          }
          return surveyStepItem;
        },
      );

      return {
        ...state,
        currentSurveyStep: {
          ...state.currentSurveyStep,
          surveyStepItems: newStepItems,
        },
      };
    }
    case HAS_INVALID_ANSWER: {
      return {
        ...state,
        hasError: true,
        hasErrorToast: true,
        toastErrorMessage: '回答に不備があります。',
      };
    }
    case RESET_ERROR_TOAST: {
      return {
        ...state,
        hasErrorToast: false,
      };
    }
    case REQUEST_POST_ANSWERS: {
      return {
        ...state,
      };
    }
    case SUCCESS_POST_ANSWERS: {
      const { currentStepNumber, payload, deviceVariant } = action;
      const newSurveySteps = [...state.surveySteps];

      // エンゲージメント・ステータスの設問でSP版の場合は 10 → 0 に並び替える
      const sortedSurveyStep = reverseChoices(payload, deviceVariant);

      if (newSurveySteps[currentStepNumber - 1]) {
        return {
          ...state,
          totalCount: sortedSurveyStep.totalCount,
        };
      }

      // 遷移後のstepを更新
      const newStepItems = sortedSurveyStep.currentSurveyStep.surveyStepItems.map(
        (surveyStepItem: SurveyStepItemTypes) => {
          if (surveyStepItem.isRequired) {
            if (surveyStepItem.answer.value) {
              return { ...surveyStepItem, valid: true };
            }
            return { ...surveyStepItem, valid: false };
          }
          return surveyStepItem;
        },
      );

      newSurveySteps[currentStepNumber - 1] = {
        ...sortedSurveyStep.currentSurveyStep,
        surveyStepItems: newStepItems,
      };

      return {
        ...state,
        totalCount: sortedSurveyStep.totalCount,
        surveySteps: newSurveySteps,
      };
    }
    case FAILURE_POST_ANSWERS: {
      return {
        ...state,
        hasErrorToast: true,
        toastErrorMessage: '回答に失敗しました。時間を置いて再度お試しください。',
        slideDirection: '',
      };
    }
    case SLIDE_NEXT_STEP: {
      return {
        ...state,
        slideDirection: 'next',
      };
    }
    case SLIDE_PREV_STEP: {
      return {
        ...state,
        slideDirection: 'prev',
      };
    }
    case RESET_KEY_BIND_EXPLANATION: {
      return {
        ...state,
        isVisibleKeyBindExplanation: false,
      };
    }
    case REQUEST_POST_COMPLETE_SURVEY: {
      return {
        ...state,
      };
    }
    case SUCCESS_POST_COMPLETE_SURVEY: {
      return {
        ...state,
      };
    }
    case FAILURE_POST_COMPLETE_SURVEY: {
      return {
        ...state,
        hasErrorToast: true,
        toastErrorMessage: '回答を確定できません。回答に不備がないかご確認ください。',
        slideDirection: '',
      };
    }
    default: {
      return state;
    }
  }
};

export default surveyReducer;
